import React, { useMemo, useEffect, useState } from "react";
import {
  TextField,
  Typography,
  Grid,
  Breadcrumbs,
  Link,
  Box,
  Button,
  Snackbar,
  Alert,
  Tooltip,
} from "@mui/material";
import Layout from "../../layout/Layout";
import { MaterialReactTable } from "material-react-table";
import { MobileDatePicker } from "@mui/x-date-pickers";

import { addStoreAPI, fetchStatusByParent, listStoreAPI } from "../../config";
import { apiData } from "../../services/api_service";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { emirates, storeType } from "../../components/constants";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { LoadingButton } from "@mui/lab";
import { FileDownload } from "@mui/icons-material";
import * as XLSX from "xlsx";
import { fitColumns } from "../../utils/excelFit";
import { writeXlsxFrozen } from "../../utils/xlsxFreeze";
const StoreList = () => {
  const [columnFilters, setColumnFilters] = useState([]);
  const [sorting, setSorting] = useState([]);
  const [loading, setLoading] = useState(false);

  const [rowCount, setRowCount] = useState(0);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 100,
  });
  // ✅ Table Columns
  const [storeData, setStoreData] = useState([]);
  const [status, setStatus] = useState([]);
  const [storeTypes, setStoreTypes] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchStatus = async () => {
      const data = {
        intParentId: 222,
      };

      try {
        const result = await apiData("get", fetchStatusByParent, data);
        if (result.success) {
          setStoreTypes(result.data);
        }
      } catch (error) {
        console.error("Failed to fetch units:", error);
      }
    };

    fetchStatus();
  }, []);

  useEffect(() => {
    const fetchStatus = async () => {
      const data = {
        intParentId: 1,
      };

      try {
        const result = await apiData("get", fetchStatusByParent, data);
        if (result.success) {
          setStatus(result.data);
        }
      } catch (error) {
        console.error("Failed to fetch units:", error);
      }
    };

    fetchStatus();
  }, []);
  const columns = useMemo(() => [
    {
      accessorKey: "store_name",
      header: "Source Name",
      Cell: ({ row }) => <strong>{row.original.store_name}</strong>, // bold text
      size: 150,
    },
    {
      accessorKey: "store_type",
      header: "Source Type",
      Cell: ({ row }) => {
        const name = storeTypes.find(
          (item) => item.id === row.original.store_type
        )?.name;
        return name || "N/A";
      },
      size: 110,
      filterVariant: "select",
      filterSelectOptions: storeTypes.map((e) => ({
        text: e.name,
        value: e.id,
      })),
    },
    {
      accessorKey: "contact_person",
      header: "Contact Person",
      Cell: ({ row }) => row.original.contact_person,
      size: 120,
    },
    {
      accessorKey: "phone",
      header: "Phone",
      Cell: ({ row }) => row.original.phone,
      size: 100,
    },
    {
      accessorKey: "email",
      header: "Email",
      Cell: ({ row }) => row.original.email,
      size: 150,
    },
    {
      accessorKey: "emirate",
      header: "Emirate",
      Cell: ({ row }) => {
        const name = emirates.find(
          (item) => item.id === row.original.emirate
        )?.name;
        return name || "N/A";
      },
      size: 100,
      filterVariant: "select",
      filterSelectOptions: emirates.map((e) => ({ text: e.name, value: e.id })),
    },
    {
      accessorKey: "created_at",
      header: "Created At",
      Cell: ({ row }) => moment(row.original.created_at).format("DD-MM-YYYY"),
      Filter: ({ column }) => {
        const value = column.getFilterValue() || null;

        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              value={value ? dayjs(value, "YYYY-MM-DD") : null}
              inputFormat="DD-MM-YYYY"
              onChange={(newValue) => {
                if (newValue) {
                  const formatted = dayjs(newValue).format("YYYY-MM-DD");
                  column.setFilterValue(formatted);
                } else {
                  column.setFilterValue(null);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  variant="standard"
                  placeholder="Select Date"
                  sx={{
                    "& .MuiInputBase-input": {
                      color: "#fff !important",
                    },
                    "& .MuiInput-underline:before": {
                      borderBottomColor: "#fff !important",
                    },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                      borderBottomColor: "#fff !important",
                    },
                    "& .MuiInput-underline:after": {
                      borderBottomColor: "#fff !important",
                    },
                    "& .MuiInputBase-input::placeholder": {
                      color: "#fff !important",
                      opacity: 0.7,
                    },
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {params.InputProps.endAdornment}
                        {value && (
                          <IconButton
                            size="small"
                            onClick={() => column.setFilterValue(null)}
                            sx={{ color: "#fff" }}
                          >
                            ✕
                          </IconButton>
                        )}
                      </>
                    ),
                  }}
                />
              )}
            />
          </LocalizationProvider>
        );
      },
      size: 110,
    },
    {
      accessorKey: "status",
      header: "Status",
      Cell: ({ row }) => {
        const name = status.find(
          (option) => option.id === row.original.status
        )?.name;
        return (
          <span
            style={{
              color: row.original.status === 2 ? "green" : "red",
              fontWeight: 600,
            }}
          >
            {name || "N/A"}
          </span>
        );
      },
      size: 90,
      filterVariant: "select",
      filterSelectOptions: [
        {
          label: "Active",
          title: "Active",
          value: 2,
        },
        {
          label: "InActive",
          title: "InActive",
          value: 3,
        },
      ],
    },
    {
      accessorKey: "edit",
      header: "Action",
      Cell: ({ row }) => (
        <IconButton
          color="primary"
          onClick={() => navigate(`/store/add/${row.id}`)} // pass row data to edit function
        >
          <EditIcon />
        </IconButton>
      ),
      enableColumnFilter: false,
      enableSorting: false,
      size: 70,
    },
  ]);

  useEffect(() => {
    async function fetchData() {
      const payload = {
        pagination: JSON.stringify({
          pageIndex: pagination.pageIndex,
          pageSize: pagination.pageSize,
        }),
        sorting: sorting.length > 0 ? JSON.stringify(sorting[0]) : null,
        search: columnFilters.length > 0 ? JSON.stringify(columnFilters) : null,
      };
      const response = await apiData("get", listStoreAPI, payload);
      if (response.success) {
        setStoreData(response.data);
        setRowCount(response.pagination);
      }
    }

    fetchData();
  }, [columnFilters, sorting, pagination]);

  const handleExportData = async () => {
    try {
      setLoading(true);

      // Prepare payload with all filters, sorting, search, but unlimited pageSize
      const payload = {
        pagination: JSON.stringify({
          pageIndex: 0,
          pageSize: 10000000,
        }),
        sorting: sorting.length > 0 ? JSON.stringify(sorting[0]) : null,
        search: columnFilters.length > 0 ? JSON.stringify(columnFilters) : null,
      };

      const response = await apiData("get", listStoreAPI, payload);
      const dataArray = Array.isArray(response.data) ? response.data : [];
      if (dataArray.length === 0) {
        alert("No data to export!");
        return;
      }

      const exportData = dataArray.map((item, index) => {
        const emirateName =
          emirates.find((e) => e.id == item.emirate)?.name || "";
        const storeName =
          storeTypes.find((e) => e.id == item.store_type)?.name || "";

        return {
          "#": index + 1,
          "Source Name": item.store_name || "",
          "Source Type": storeName,
          "Contact Person": item.contact_person || "",
          Phone: item.phone || "",
          Email: item.email || "",
          Emirate: emirateName,
          "Created At": item.created_at
            ? moment(item.created_at).format("DD-MM-YYYY")
            : "",
          Status:
            item.status === 2
              ? "Active"
              : item.status === 3
              ? "InActive"
              : "",
        };
      });

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      fitColumns(ws);
      XLSX.utils.book_append_sheet(wb, ws, "source_list");

      const fileName = `source_list_${moment().format(
        "DD_MM_YYYY"
      )}.xlsx`;
      writeXlsxFrozen(XLSX, wb, fileName);
      setSuccessMessage("Excel Downloaded Successfully!");
    } catch (error) {
      console.error("Export failed:", error);
      alert("Failed to export data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Snackbar
        open={!!successMessage}
        autoHideDuration={3000} // hide after 3 seconds
        onClose={() => setSuccessMessage("")}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSuccessMessage("")}
          severity="success"
          sx={{
            width: "100%",
            backgroundColor: "#28a745",
            color: "#fff",
            fontWeight: 600,
          }}
        >
          {successMessage}
        </Alert>
      </Snackbar>
      <Grid className="employee-form bold-header">
        <Grid container spacing={3}>
          {/* Header */}
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Source List
            </Typography>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">Source</Typography>
              <Typography color="text.primary">List</Typography>
            </Breadcrumbs>
          </Grid>
          {/* Header Actions */}
          <Grid
            textAlign="right"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <LoadingButton
              size="medium"
              variant="contained"
              color="success"
              className="button_first"
              component={Link}
              href="/store/add"
              startIcon={<AddIcon />}
            >
              {" "}
              Add Source
            </LoadingButton>

            <LoadingButton
              size="medium"
              variant="contained"
              color="primary"
              onClick={() => navigate(-1)}
              startIcon={<ArrowBackIosIcon />}
            >
              Back
            </LoadingButton>
          </Grid>
        </Grid>

        {/* Table */}
        <Grid className="form_design">
          <MaterialReactTable
            enableGlobalFilter={false}
            enableGlobalFiltering={false}
            columns={columns}
            data={storeData}
            layoutMode="grid"
            muiToolbarAlertBannerProps={{
              sx: {
                "& .MuiButtonBase-root": {
                  color: "red",
                  fontWeight: "500",
                  width: "100px",
                  "&:hover": {
                    background:
                      "linear-gradient(90deg, rgba(255, 153, 153, 0.8) 30%, rgba(255, 187, 187, 0.9) 100%)",
                  },
                },
              },
            }}
            getRowId={(row) => row.id}
            enableRowNumbers
            initialState={{ showColumnFilters: false }}
            rowNumberMode="original"
            enableFullScreenToggle={false}
            enableStickyHeader
            manualFiltering
            manualPagination
            manualSorting
            onColumnFiltersChange={setColumnFilters}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            muiLinearProgressProps={{
              color: "inherit",
              sx: { height: "4px" },
            }}
            state={{
              columnFilters,
              isLoading: loading,
              pagination,
              // showAlertBanner: isError,
              // showProgressBars: isRefetching,
              sorting,
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: "calc(100vh - 240px)",
                minHeight: 450,
                overflowY: "auto",
              },
            }}
            muiTableBodyRowProps={({ row }) => ({
              sx: {
                backgroundColor: row.index % 2 === 0 ? "#fffff" : "#edf8fd",
              },
            })}
            muiTableHeadCellProps={{
              sx: {
                padding: "8px",
                border: "1px solid #ccc",
                color: "#fff !important",
                fontWeight: "bold",
                backgroundColor: "#1976d2",
                "& svg": {
                  color: "#fff !important",
                },
                "& .MuiTableSortLabel-root": {
                  color: "#fff !important",
                  "&.Mui-active": {
                    color: "#fff !important",
                    "& .MuiTableSortLabel-icon": {
                      color: "#fff !important",
                    },
                  },
                },
                "& .MuiTableSortLabel-icon": {
                  color: "#fff !important",
                },
                "& .MuiInputBase-input": {
                  color: "#fff !important",
                  textFillColor: "#fff !important",
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#fff !important",
                  opacity: 0.8,
                },
                "& .MuiInput-underline:before": {
                  borderBottomColor: "#fff !important",
                },
                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                  borderBottomColor: "#fff !important",
                },
                "& .MuiInput-underline:after": {
                  borderBottomColor: "#fff !important",
                },
              },
            }}
            muiTableBodyCellProps={{
              sx: {
                // fontSize: '14px',
              },
            }}
            renderTopToolbarCustomActions={({ table }) => (
              <>
                <Box
                  sx={{
                    display: "flex",
                    gap: "1rem",
                    p: "0.5rem",
                    justifyContent: "space-between",
                    flexGrow: 1,

                    flexWrap: "wrap",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {/* RIGHT SIDE BUTTON */}
                    <Tooltip title="Export data to excel sheet" arrow>
                      <Button
                        onClick={handleExportData}
                        style={{ background: "#1a73e829" }}
                        startIcon={<FileDownload />}
                        // startIcon={<IconTableExport />}
                      >
                        Export To Excel
                      </Button>
                    </Tooltip>
                  </Box>
                </Box>
              </>
            )}
          />
        </Grid>
      </Grid>
    </Layout>
  );
};

export default StoreList;
